
<template>
  <div class="category">
    <!-- <van-nav-bar title="分类"></van-nav-bar> -->
    <van-search
      class="fixed search"
      placeholder="请输入搜索关键词"
      v-model="keyword"
      @input="search"
    />

    <van-tree-select
      :items="categoryList"
      :main-active-index.sync="activeIndex"
    >
      <template slot="content">
        <ul class="flex jc-sa fww" style="padding-bottom: 80px">
          <li class="item" v-for="(item, index) in productList" :key="index">
            <img :src="item.imgUrl" alt="" />
            <p class="f12">{{ item.masterName | Fname }}</p>
          </li>
          <li class="item"></li>
        </ul>
      </template>
    </van-tree-select>
    <Footer></Footer>
  </div>
</template>

<script>
import { Search } from "vant";
import { TreeSelect } from "vant";
import Footer from "@/components/Footer";
export default {
  components: {
    [TreeSelect.name]: TreeSelect,
    [Search.name]: Search,
    Footer,
  },
  data() {
    return {
      tiemer: null,
      keyword: "",
      categoryId: this.$route.query.categoryId,
      activeIndex: 0,
      productList: [],
      categoryList: [],
    };
  },

  created() {
    this.getCategory();
  },

  filters: {
    Fname(name) {
      name = name.slice(4, 22);
      return name;
    },
  },

  watch: {
    activeIndex(index) {
      this.getProductList(this.categoryList[index].categoryId);
    },
  },

  methods: {
    search() {
      clearInterval(this.tiemer); 
      this.tiemer = setTimeout(() => { 
        if (this.keyword) {
          this.$get("/product/search", { keyword: this.keyword }).then(
            (res) => {
              this.activeIndex = -1;
              this.productList = res.list;
            }
          );
        } else {
           this.activeIndex = 0;
        }
      }, 500);
    },

    // 根据分类id获取商品列表
    async getProductList(categoryId) {
      try {
        this.$loading(1);
        let url = "/product/list?categoryId=" + categoryId;
        let res = await this.$get(url);
        this.productList = res.list;
        this.$loading(0);
      } catch (error) {}
    },

    // 获取分类类别
    async getCategory() {
      try {
        this.$loading(1);
        let url = "/category/all";
        let res = await this.$get(url);
        this.categoryList = res.list.map((item) => {
          return { categoryId: item.categoryId, text: item.name };
        });

        if (this.categoryId) {
          this.activeIndex = this.categoryList.findIndex(
            (item) => item.categoryId == this.categoryId
          );
          this.getProductList(this.categoryId);
        } else {
          this.getProductList(res.list[0].categoryId);
        }
        this.$loading(0);
      } catch (error) {
        this.$fail(error);
      }
    },
  },
};
</script>

<style lang="less">
.category {
  padding-top: 50px;
  .search {
    top: 0;
    width: 100%;
    z-index: 10;
    background: #fff;
  }

  .item {
    width: 100px;
  }

  img {
    width: 90px;
  }
  .van-sidebar {
    position: fixed;
    height: 100%;
  }
  .van-tree-select {
    height: 100vh !important;
  }

  .van-tree-select__content {
    margin-left: 85px;
    min-height: 100vh;
  }
  .van-sidebar-item--select::before {
    height: 90%;
    width: 2px;
  }
}
</style>




